import { MutableRefObject, useLayoutEffect, useRef } from 'react';
import { RecoilValue, useRecoilValue } from 'recoil';

export const useRecoilValueRef = <T>(recoilValue: RecoilValue<T>): MutableRefObject<T> => {
  const value = useRecoilValue(recoilValue);
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  })
  return ref;
}
